import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalState from './state/GlobalState';
import { AuthProvider } from './context/AuthProvider';
import { HashRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit'

import { Provider } from "react-redux"
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist"

import storage from "redux-persist/lib/storage"
import { PersistGate } from 'redux-persist/integration/react';



const persistConfig = { key: "auth", storage, version: 1 };
const persistreducer = persistReducer(persistConfig, GlobalState);

const root = ReactDOM.createRoot(document.getElementById('root'));

const store = configureStore({
  reducer: {
    globalData: persistreducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      },
    }),

});


root.render(
  <React.StrictMode>

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistStore(store)}>
      <HashRouter>
        <AuthProvider>
        <App />
        </AuthProvider>
        </HashRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


